module.exports = __webpack_public_path__ + "HelveticaBold.299c7b1c61d64812caae.svg";


//////////////////
// WEBPACK FOOTER
// /var/www/minhaloga-cliente/src/app/@theme/fontes/Helvetica/HelveticaBold.svg
// module id = ../../../../../src/app/@theme/fontes/Helvetica/HelveticaBold.svg
// module chunks = styles